import { useMemo } from 'react'
import { Permission } from './permissions.constants'
import { useUser } from './useUser'

export function useAnyPermission(permissions: readonly Permission[]): boolean {
  const user = useUser()
  const userPermissions = useMemo(() => new Set(user?.permissions), [user])
  return permissions.some(permission => userPermissions.has(permission))
}
